module.exports = __webpack_public_path__ + "img/add-purple.61539e12.svg";